module.exports = __webpack_public_path__ + "img/logo.91958982.png";